import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { signInWithGoogle, logout, auth } from "../firebase";
import axios from "axios";
import { toast } from "react-toastify";

export default function AdminLogin() {
  const [checking, setChecking] = useState(true);
  const [user, setUser] = useState(null);
  const [authorized, setAuthorized] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "NSC Admin Login";
  }, []);

  useEffect(() => {
    const unsub = auth.onAuthStateChanged(async (u) => {
      setUser(u);

      if (u) {
        const token = await u.getIdToken();

        try {
          const res = await axios.get("/api/roles/is-admin", {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });

          if (res.data.admin) {
            setAuthorized(true);
            navigate("/admin");
          }
        } catch (err) {
          toast.error("Error checking admin status");
        }
      }

      setChecking(false);
    });

    return unsub;
  }, [navigate]);

  if (checking) return null;

  if (!user) {
    return (
      <div style={{ backgroundColor: "#F0F0F1", minHeight: "100vh", paddingTop: "80px" }}>
        <div className="container py-5">
          <div className="d-flex flex-column align-items-center">
            <div className="text-center mb-4">
              <h1 className="h2">NSC Admin Dashborad</h1>

              <div className="card shadow-sm rounded-0 bg-white mt-3" style={{ padding: "30px", width: "350px" }}>
                <p className="mb-2 me-auto">Choose a sign-in method:</p>
                <button className="btn btn-admin" onClick={signInWithGoogle}>
                  Sign in with Google
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container py-5 text-center">
      <p>Unauthorized access for {user.email}</p>
      <button className="btn btn-secondary" onClick={logout}>
        Sign out
      </button>
    </div>
  );
}
